<template>
  <div class="receive">
      <section class="receive-header">
      <z-icon
        v-if="!loading"
        color="#999999"
        name="n_v2c87f033cd4fc40a29e2f1d910abae89a.png"
        size="40px"
      />
      <div>
        <div class="receive-header-title"><b>恭喜您！已领取放心转保障</b></div>
        <div class="receive-header-content">转转订单最高可赔付2000元</div>
      </div>
    </section>

    <section class="receive-detial">
      <div class="receive-detial-item">
        <div class="receive-detial-item-label">被保障人</div>
        <div class="receive-detial-item-valuue">{{ data.nickName }}</div>
      </div>
      <div class="receive-detial-item">
        <div class="receive-detial-item-label">保障有效期</div>
        <div class="receive-detial-item-valuue">{{ formatTime(data.startTime, data.endTime) }}</div>
      </div>
    </section>

    <div class="receive-image" @click="toTip()">
      <z-image width="100%" px2rem src="https://pic1.zhuanstatic.com/zhuanzh/9464a82c-5cb7-43d6-9b6c-ff03613ff62c.png" />
    </div>

    <question-list />

    <z-button-group v-show="!loading">
      <z-button type="primary" btn-class="bottombtn" @click="toSelect()">申请赔付</z-button>
    </z-button-group>
    </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Icon, Button, ButtonGroup, Image } from '@zz-common/zz-ui'
import { lego } from '@zz-common/lego'
import { queryParams } from '../../../lib/utils'
import { getPayMoneyReceive } from '../../../api/resourceApi'
import QuestionList from '../Components/QuestionList'

const query = queryParams()
export default {
  name: 'ReceiveComp',
  data() {
    return {
      id: query.id || this.$route.query.id || 0,
      receiveSource: query.receiveSource || this.$route.query.receiveSource || 'unknow', //领取来源。0:安全中心|1:push|2:私信3:重新领取
      loading: false,
      data: {}
    }
  },
  components: {
    zIcon: Icon,
    zButtonGroup: ButtonGroup,
    zButton: Button,
    zImage: Image,
    QuestionList
  },
  methods: {
    getrReceive() {
      // this.loading = true
      // const res = await getPayMoneyReceive()
      // this.loading = false
      // this.data = res | {}

      this.loading = true
      getPayMoneyReceive()
        .then((res) => {
          this.loading = false
          this.data = res || {}
          console.log('请求成功', res)
        })
        .catch((err) => {
          this.loading = false
          console.error(err)
        })
    },
    toSelect() {
      const targetUrl =
          'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneySelect&applySource=receive'
      setTimeout(() => {
        native.skipToUrl({
          targetUrl,
          needClose: '1'
        })
      }, 200)
    },
    toLink() {
      const targetUrl =
          'https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=PreventFoolExample'
      setTimeout(() => {
        native.skipToUrl({ targetUrl })
      }, 200)
    },
    formatTime(start, end) {
      return this.transTime(start) + ' - ' + this.transTime(end)
    },
    transTime(timeStamp) {
      return timeStamp ? new Date(Number(timeStamp)).format('YYYY.MM.DD') : ''
    },
    toTip() {
      native.skipToUrl({
        targetUrl:
            'https://feentry.zhuanzhuan.com/spam_cloudInspection?clientid=PreventFoolExample'
      })
    }
  },
  mounted() {
    native.setTitle({
      title: '放心转'
    })
    const obj = {
      label: '赔付说明',
      url: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
      newPageTitle: '赔付说明',
      needLogin: 0,
      color: '#111111'
    }
    native.wrap('setRightBtn')(obj)
    this.getrReceive()
    lego.send({
      pagetype: 'ZZUP_SAFECENTER_HOME',
      actiontype: 'RECEIVE-SUCCESS',
      backup: {
        receiveSource: this.receiveSource
      }
    })
  },
  destroyed() {},
  beforeRouteEnter(_to, _from, next) {
    // const obj = {
    //   label: '赔付说明',
    //   url: 'https://feentry.zhuanzhuan.com/PayMoney?clientid=PayMoneyDescription',
    //   newPageTitle: '赔付说明',
    //   needLogin: 0,
    //   color: '#111111'
    // };
    next((_vm) => {
      // native.wrap('setRightBtn')(obj)
    })
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>
